export default "__VITE_ASSET__vxp$jbwb__"